export * from "./GetPartScore";